import React from 'react';
import i18n from '../../utils/i18n';
import {toLocalDateTime} from '../../utils/date-helpers';
import IssueFieldInlineEdit from './IssueFieldInlineEdit';
import TextFieldInlineEdit from './TextFieldInlineEdit';
import Label from '@adsk/bim360-matrix-react-label';
import {issueAttributesType} from '../../constants/proptype-validation';
import {ISSUE_ATTRIBUTE_NAMES} from '../../constants/issue-attribute-names';
import PropTypes from 'prop-types';

const ResponseInlineEdit = ({issue, className, styleType, getEntityDisplayNameById}) => {
  const {[ISSUE_ATTRIBUTE_NAMES.OFFICIAL_RESPONSE]: officialResponse} = issue;
  const answerer = getEntityDisplayNameById(officialResponse?.respondedBy, i18n.t('userUndefined'), null);

  return (
    <div className="ResponseInlineEdit">
      <div className="IssueFieldInlineEdit__label-container">
        <Label className="IssueFieldInlineEdit__label">{i18n.t('answer.label')}</Label>
      </div>
      {officialResponse?.response && (
        <div className="ResponseInlineEdit__answered-by">
          {i18n.t('answer.updatedBy', {answerer, answeredAt: toLocalDateTime(officialResponse.respondedAt)})}
        </div>
      )}
      <TextFieldInlineEdit
        issue={issue}
        placeholder={i18n.t('unspecifiedValue')}
        attributeName={[ISSUE_ATTRIBUTE_NAMES.OFFICIAL_RESPONSE, 'response']}
        className={className}
        data-testid="ResponseInlineEdit"
        styleType={styleType}
        linkify
      />
    </div>
  );
};

ResponseInlineEdit.displayName = 'ResponseInlineEdit';

ResponseInlineEdit.propTypes = {
  issue: issueAttributesType,
  className: PropTypes.string,
  styleType: PropTypes.oneOf(Object.values(IssueFieldInlineEdit.StyleTypes)),
  getEntityDisplayNameById: PropTypes.func.isRequired
};

export default ResponseInlineEdit;
